import { ROUTE_SHIPPER_PROFILE } from './lib/shared/routes';

export { DeliveryShipperFeatureProfileModule } from './lib/delivery-shipper-feature-profile.module';
export { ROUTE_SHIPPER_PROFILE };
